import { subtract } from 'vend-number'
import {
  getOutstandingBalance,
  hasPayments,
  isReturn,
} from '../../../functions/sale'
import { applyLspCashDiscountToOutstanding } from '../../../functions/payments'
import { Payment } from '../../../models/payment'
import { ReduxCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'

export type LspCashDiscountBlockedSale = Pick<
  ReduxCurrentSale,
  'finals' | 'payments' | 'payAccountBalance' | 'returnFor'
>

/** True when the merchant has entered less than the full outstanding balance. */
export const isPartialAmountTendered = (
  outstandingBalance: number,
  amountTendered: string
): boolean =>
  outstandingBalance > 0 &&
  amountTendered !== '' &&
  !Number.isNaN(Number(amountTendered)) &&
  subtract(outstandingBalance, amountTendered) > 0

/** True when the sale already has payments recorded and is not fully settled. */
export const hasPartialPaymentsRecorded = (
  outstandingBalance: number,
  payments: Payment[]
): boolean => hasPayments({ payments }) && outstandingBalance > 0

/** True when LSPay cash discounting must not be offered for the current sale. */
export const isLspCashDiscountBlocked = (
  amountTendered: string,
  lspCashDiscountPercentage: number,
  sale: LspCashDiscountBlockedSale
): boolean => {
  const outstandingBalance = getOutstandingBalance(sale)

  if (hasPartialPaymentsRecorded(outstandingBalance, sale.payments)) {
    return true
  }

  const referenceBalance = isReturn(sale)
    ? outstandingBalance
    : Number(
        applyLspCashDiscountToOutstanding(
          outstandingBalance,
          sale.finals.exclusivePrice,
          lspCashDiscountPercentage,
          sale.finals.tax
        ).toFixed(2)
      )

  return isPartialAmountTendered(referenceBalance, amountTendered)
}
